import { ValueTypeAggregationStrategies } from "pokal_api"
import DocumentationComponent from "./DocumentationComponent"
import { DATA_AGGREGATION_DOC, TREND_DOC } from "../documentation/Documentation"

interface SelectFieldProps {
    value: number
    setValue: (strategy: ValueTypeAggregationStrategies) => void
}

function opt(label: string, key: number) {
    return { label, intern: key }
}

function SelectPassiveAggregationStrategyField(props: SelectFieldProps) {
    const options = [
        opt("Kombinierte Darstellung", 0),
        opt("Maximalwert-Darstellung", 1),
        opt("Minimalwert-Darstellung", 2),
        opt("Durchschnitts-Darstellung", 3),
        opt("Vollständige Darstellung", 4)
    ]

    return (
        <div className={"w-full"}>
            <div className={"text-sm w-full"}>
                Strategie der{" "}
                <DocumentationComponent documentation={DATA_AGGREGATION_DOC}>
                    Datenaggregation
                </DocumentationComponent>
            </div>
            <select
                value={props.value}
                className={"rounded w-full"}
                onChange={(e) => props.setValue(Number(e.target.value))}>
                {options.map((option) => (
                    <option key={option.intern} value={option.intern}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    )
}

export default SelectPassiveAggregationStrategyField
